/** User-facing copy for store listing POST failures (multer + related). */

const LIMIT_SIZE_HINT =
  "Each photo must be 1 MB or smaller. Use JPG, PNG, or WebP — try compressing or resizing images, then upload again.";

const LIMIT_TYPE_HINT =
  "Photos must be JPG, JPEG, PNG, or WebP only. Convert the file or pick a different image.";

const LIMIT_COUNT_HINT =
  "Too many images in one upload (max 20). Remove some photos and try again.";

const UNEXPECTED_FIELD_HINT =
  "The upload could not be read. Refresh the page and try again.";

/**
 * Prefer server `code` (Multer) and `error` text; then `message`. Returns null if nothing to show.
 * @param {unknown} data Parsed JSON body
 * @returns {string|null}
 */
export function resolveListingSubmitErrorMessage(data) {
  if (!data || typeof data !== "object") return null;

  const code = data.code;
  if (code === "LIMIT_FILE_SIZE") return LIMIT_SIZE_HINT;
  if (code === "LIMIT_FILE_COUNT") return LIMIT_COUNT_HINT;
  if (code === "LIMIT_UNEXPECTED_FILE") return UNEXPECTED_FIELD_HINT;

  const errRaw = String(data.error || "").trim();
  if (errRaw) {
    const lower = errRaw.toLowerCase();
    if (lower.includes("only images")) return LIMIT_TYPE_HINT;
    if (
      lower.includes("too large") ||
      lower.includes("file too large") ||
      lower.includes("max size") ||
      lower.includes("limit file size")
    ) {
      return LIMIT_SIZE_HINT;
    }
    if (lower.includes("too many files")) return LIMIT_COUNT_HINT;
    if (lower.includes("unexpected field")) return UNEXPECTED_FIELD_HINT;
    return errRaw.replace(/^error:\s*/i, "").trim() || errRaw;
  }

  const msg = String(data.message || "").trim();
  if (msg) return msg;

  return null;
}
